import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInitialState } from "../helpers";
import { ApiProvider } from "../ApiProvider";
import { AxiosError } from "axios";
import { TPickedMarketplace } from "@src/components/syncLogs/SyncLogs";

export type TSyncLogsResponse = {
	SyncLogId: number;
	ListingId: number;
	Source: string;
	Action: string;
	IsException: boolean;
	Data: string;
	Result: string;
	CreatedDate: string | Date;
};

type TPayload = {
	listingId: number;
	marketplace: TPickedMarketplace;
};

const initialState = getInitialState<Array<TSyncLogsResponse>>([]);

const getPayloadUrl = (marketplace: TPickedMarketplace) => {
	switch (marketplace) {
		case "ticketsNow":
			return "api/Pricing/GetTNowSyncLogs";
		case "seatGeek":
			return "api/Pricing/GetSeatGeekSyncLogs";
		case "stubHub":
			return "api/Pricing/GetStubHubSyncLogs";
		case "ticketNetwork":
			return "api/Pricing/GetTNDSyncLogs";
	}
};

export const getSyncLogs = createAsyncThunk<Array<TSyncLogsResponse>, TPayload, { rejectValue: string }>(
	"syncLogs/getSyncLogs",
	async ({ listingId, marketplace }, { rejectWithValue }) => {
		try {
			const url = getPayloadUrl(marketplace);
			return await ApiProvider.default.post<Array<TSyncLogsResponse>>(url, {
				listingId: listingId,
			});
		} catch (error) {
			if (error instanceof AxiosError) return rejectWithValue(error.message);
			return rejectWithValue("Unknown error");
		}
	},
);

export const syncLogs = createSlice({
	name: "syncLogs",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSyncLogs.pending, (state) => {
				state.error = null;
				state.data = [];
				state.loading = true;
			})
			.addCase(getSyncLogs.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(getSyncLogs.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as string;
			});
	},
});
